import React from "react";
import {abbvLocation} from "../../../helpers/locations/LocationNames";
import { withStyles } from "@mui/styles";

const styles = {
  cellSubtext:{
    fontSize:'0.85em',
    whiteSpace:'nowrap',
    fontWeight:'300',
    lineHeight: '1em'
  },
  locationText: {
    whiteSpace:'nowrap',
  },
};

function Location(props){
  const {location, classes, ...rest} = props
  return <div {...rest}>
    {location ? <>
      <div className={classes.locationText}>
        {abbvLocation(location)}
      </div>
      <div className={classes.cellSubtext}>
        {[location.latitude, location.longitude].filter(item => !!item).map(item => item.toFixed(2)).join(', ')}
      </div>
    </>
    : null}
  </div>;
}

export default withStyles(styles)(Location);